import React, { useCallback, useContext, useMemo } from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import DataRoomEmptyImage from 'assets/images/data-room-upload.webp';
import { useTranslation } from 'react-i18next';
import PlusIcon from 'icons/Plus.icon';
import { ConditionalLink } from 'components/ConditionalLink';
import ListingContext from '../../../../providers/Listing/Listing.context';
import { NEW_WINDOW_PROPS } from 'data/global';
import { getDataRoomRoute } from 'utils';
import { DATA_ROOM_LOGIN_SOURCE } from 'models/DataRoomLoginSource';

import './AddDocsToEmptyDataRoom.styles.scss';

type AddDocsToEmptyDataRoomProps = {
  className?: string;
};

const AddDocsToEmptyDataRoom: React.FC<AddDocsToEmptyDataRoomProps> = (
  props,
) => {
  const { className } = props;

  const {
    areActionsDisabled,
    dealRoom: { dataRoomId },
  } = useContext(ListingContext);

  const classes = classNames(
    'add-docs-to-empty-data-room',
    { disabled: areActionsDisabled },
    className,
  );

  const { t } = useTranslation();

  const navigateUrl = useMemo(
    () => getDataRoomRoute(dataRoomId, 'documents', DATA_ROOM_LOGIN_SOURCE.PORTFOLIO),
    [dataRoomId],
  );

  const handleOnClick = useCallback(() => {
    if (areActionsDisabled) return;
    window.open(navigateUrl, NEW_WINDOW_PROPS.target);
  }, [areActionsDisabled, navigateUrl]);

  return (
    <div className={classes} onClick={handleOnClick}>
      <div className="card-heading">
        <p>{t('nextPopulateDataRoom')}</p>
      </div>

      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="Upload files to Data room"
      />

      <ConditionalLink
        isDisabled={areActionsDisabled}
        disabledClassName={classNames('ncoded-button--solid', 'as-button')}
        to={navigateUrl}
        {...NEW_WINDOW_PROPS}
      >
        {t('uploadFiles')}
        <PlusIcon />
      </ConditionalLink>
    </div>
  );
};

export default AddDocsToEmptyDataRoom;
